export const EMAIL_PREFIX = 'mailto:';
